import { shipmentShowValidate } from "../../application/dtos/shipment_show_validate";

export class shipmentShowEntity {
    constructor({ id, uniqueOrderNumber, shipmentNumber, shippingService, externalShippingService, total, shippingPrice, invoice, totalWeight, labelDownload, noteDownload, isRfid, cod, createdAt, shipmentProductDetail, orderStatus, order, warehouse, charge, consignee, box, client, orderReturned, product, masterShipmentDetail, hasFiles }){
        this.id = id;
        this.uniqueOrderNumber = uniqueOrderNumber; 
        this.shipmentNumber = shipmentNumber;
        this.shippingService = shippingService;
        this.externalShippingService = externalShippingService;
        this.total = total;
        this.shippingPrice = shippingPrice;
        this.invoice = invoice;
        this.totalWeight = totalWeight;
        this.labelDownload = labelDownload;
        this.noteDownload = noteDownload;
        this.isRfid = isRfid;
        this.cod = cod;
        this.createdAt = createdAt;
        this.shipmentProductDetail = shipmentProductDetail;
        this.orderStatus = orderStatus;
        this.order = order;
        this.warehouse = warehouse;
        this.charge = charge;
        this.consignee = consignee;
        this.box = box;
        this.client = client;
        this.orderReturned = orderReturned;
        this.product = product;
        this.masterShipmentDetail = masterShipmentDetail;
        this.hasFiles = hasFiles;
    }

    isValid() {
        return shipmentShowValidate(this);
    }
}